// searchPeople.ts
import { analysisService } from "../../../shared/services/api/analysis/analysisService";
import { clientService } from "../../../shared/services/api/client/clientService";

export async function searchPeopleByDocument(document: string) {
	try {
		const result = await analysisService.getPeopleByDocument(document);
		if (result instanceof Error) return null;
		return result;
	} catch (err) {
		console.error("Erro ao buscar pessoa:", err);
		return null;
	}
}

export async function searchAddress(cep: string) {
	try {
		const cleanCep = cep.replace(/\D/g, ""); // Remove pontos e traços
		if (cleanCep.length !== 8) {
			throw new Error("CEP inválido");
		}

		const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
		const data = await response.json();

		if (data.erro) return null;

		return {
			addressZipcode: data.cep,
			addressStreet: data.logradouro,
			addressDistrict: data.bairro,
			addressCity: data.localidade,
			addressState: data.uf,
			addressComplement: data.complemento,
			addressIBGE: data.ibge,
		};
	} catch (err) {
		console.error("Erro ao buscar endereço via ViaCEP:", err);
		return null;
	}
}

export async function searchClientByDocument(name: string) {
	try {
		const result = await clientService.getDocument(name);
		if (result instanceof Error) return null;
		return result.data;
	} catch (err) {
		console.error("Erro ao buscar cliente:", err);
		return null;
	}
}

export async function searchPlanbyClient(id: string) {
	try {
		const result = await clientService.getByID(id);
		if (result instanceof Error) return null;
		return result;
	} catch (err) {
		console.error("Erro ao buscar cliente:", err);
		return null;
	}
}